import i18n from 'i18next';

/**
 * Returns the ISO standard version of the users language
 * We need this because we use the non-standard derivative.
 * For example: `de-DE-Sie` can not be used directly with function like `Intl.DateTimeFormat('de-DE-Sie'...)` ❌.
 * Whilst the 5 character version works  `Intl.DateTimeFormat('de-DE'...)` ✅
 */

export default function getUsersISOLocale() {
	return i18n.language.slice(0, 5); // e.g., 'en-GB'
}
